import { render, staticRenderFns } from "./BaseNotifyAlert.vue?vue&type=template&id=81f8617c&scoped=true"
import script from "./BaseNotifyAlert.vue?vue&type=script&lang=js"
export * from "./BaseNotifyAlert.vue?vue&type=script&lang=js"
import style0 from "./BaseNotifyAlert.vue?vue&type=style&index=0&id=81f8617c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f8617c",
  null
  
)

export default component.exports